import { render, staticRenderFns } from "./BarberDataSheetsList.vue?vue&type=template&id=56f2b49e"
import script from "./BarberDataSheetsList.vue?vue&type=script&lang=js"
export * from "./BarberDataSheetsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports